export default {
  header: {
    1: [
      {
        title: '1. Ceritakan apa yang memotivasi Anda untuk melamar dalam program Sekolah Penggerak?',
        contentsId: [21, 22, 23],
      },
      {
        title:
          '2. Tindakan/keputusan strategis apa yang Anda ambil dalam kurun waktu 1 tahun terakhir yang berdampak ' +
          'siginifikan pada sekolah yang Anda pimpin?',
        contentsId: [24, 25, 26, 27],
      },
      {
        title: '3. Ceritakan pengalaman Anda saat melakukan perubahan signifikan di sekolah yang Anda pimpin',
        contentsId: [28, 29, 30, 31],
      },
      {
        title:
          '4. Ceritakan pengalaman Anda sebagai Kepala Sekolah dalam melakukan pengembangan dan bimbingan terhadap ' +
          'orang lain dalam rangka mempersiapkannya mengemban peran yang menantang',
        contentsId: [32, 33, 34, 35],
      },
      {
        title:
          '5. Ceritakan pengalaman Anda meningkatkan kesadaran pentingnya untuk terus mengembangkan kapabilitas diri',
        contentsId: [36, 37, 38, 39],
      },
      {
        title:
          '6. Ceritakan pengalaman Anda membangun kerjasama dengan pihak di luar sekolah yang mendatangkan manfaat bagi sekolah',
        contentsId: [36, 37, 38, 39],
      },
      {
        title: '7. Ceritakan pengalaman Anda mengimplementasi rencana program kerja di sekolah yang Anda pimpin',
        contentsId: [36, 37, 38, 39],
      },
      {
        title:
          '8. Ceritakan pengalaman Anda mewujudkan lingkungan pembelajaran yang mengedepankan toleransi dan/atau inklusif',
        contentsId: [36, 37, 38, 39],
      },
    ],
  },
};
